import React from 'react';

const About = () => {
  return (
    <div name="about" className="w-full h-screen bg-[#0a192f] text-gray-300">
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="sm:text-right pb-8 pl-4">
            <p className="text-4xl font-bold inline border-b-4 border-pink-600">About</p>
          </div>
          <div></div>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <div className="sm:text-right text-4xl font-bold">
            <p>
              Born in 2001 in Chuadanga, Bangladesh.
              <br /> I am a developer that takes great pride in making websites that are both easy
              to use and aesthetically pleasing.
            </p>
          </div>
          <div>
            <p className="leading-6">
              When it comes to technology, I am passionate because I am a web developer. As a web
              developer, I am always pushing myself to do better, whether that means writing more
              efficient code or creating more visually attractive websites.
              <br />
              <br />
              I have extensive experience in bringing complex projects to life, and a solid
              foundation in HTML, CSS, and JavaScript. It doesn't matter if you need a basic
              brochure site or a complex e-commerce solution, I will always do my best to meet, and
              even surpass, your expectations.
              <br />
              <br />I also have a firm belief in the value of teamwork, and I welcome the
              opportunity to partner with my clients to materialize their visions. I'd love to hear
              from you if you need a web developer who can make your website idea a reality. Let's
              make something incredible, together.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
